import {AbstractExternalContact} from "@app/shared/classes/abstract-external-contact";

export class PartnerExternalContact extends AbstractExternalContact {
}
